import { render, staticRenderFns } from "./TextToSpeech.vue?vue&type=template&id=3e9a158b&"
import script from "./TextToSpeech.vue?vue&type=script&lang=js&"
export * from "./TextToSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports